import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=3097afa2&scoped=true&"
import script from "./sport.vue?vue&type=script&lang=js&"
export * from "./sport.vue?vue&type=script&lang=js&"
import style0 from "./sport.vue?vue&type=style&index=0&id=3097afa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097afa2",
  null
  
)

export default component.exports